import { isEmpty } from '../Shared/scriptts/utilities';
import { Params } from '../Shared/scriptts/search-params';
import { params, aliasMapping } from './search-main';

const analyticsLinkerQueryParams = ['_gl'];

export class URLCriteriaHelper {
    static ParseURL(existingParams: Params) {
        let myParams: Params = existingParams ? existingParams : new Params();
        let queryData = new URLSearchParams(window.location.search);
        let querySet = new Set(queryData.keys());
        for (const criteria of querySet) {            
            if (criteria in aliasMapping) {
                const queryValues = queryData.getAll(criteria);
                if (myParams[aliasMapping[criteria].JOAQueryName] instanceof Array) {
                    myParams[aliasMapping[criteria].JOAQueryName] = queryValues.filter(x => !isEmpty(x));
                } else {
                    const firstValue = queryValues[0];
                    if (firstValue === "true") {
                        myParams[aliasMapping[criteria].JOAQueryName] = true;
                    } else if (firstValue === "false") {
                        myParams[aliasMapping[criteria].JOAQueryName] = false;
                    } else {
                        myParams[aliasMapping[criteria].JOAQueryName] = isEmpty(firstValue) ? undefined : firstValue;
                    }
                }
            }
        }
        return myParams;
    }

    private static getAnalyticsLinkerQueryParams() {
        let currentQueryData = new URLSearchParams(window.location.search);
        let analyticsQueryData = new URLSearchParams();

        analyticsLinkerQueryParams.forEach(paramName => {
            currentQueryData.getAll(paramName).forEach(paramValue => analyticsQueryData.append(paramName, paramValue));
        });

        return analyticsQueryData;
    }

    static reconstructUrl(replace: boolean = false) {
        let queryData = new URLSearchParams();
        let currentUrl = new URL(window.location.href);

        for (const param in params) {
            const paramValue = params[param];
            if (!isEmpty(paramValue) && param in aliasMapping) {
                const abbreviation = aliasMapping[param].Abbreviation;

                if (Array.isArray(paramValue)) {
                    paramValue.filter(x => !isEmpty(x)).forEach(value => queryData.append(abbreviation, value));
                }
                else {
                    queryData.append(abbreviation, paramValue);
                }
            }
        }

        const analyticsQueryData = URLCriteriaHelper.getAnalyticsLinkerQueryParams();

        analyticsQueryData.forEach((value, key) => queryData.append(key, value));

        const paramString = queryData.toString();
        const nextUrl = `${currentUrl.pathname}${paramString ? `?${paramString}` : ''}${currentUrl.hash}`;

        if (replace) {
            history.replaceState({}, document.title, nextUrl);
        }
        else {
            history.pushState({}, document.title, nextUrl);
        }
    }
}
